import React, { Component } from "react";
import { AmealioLoader } from "../../Loader/AmealioLoader";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import { ButtonReusableComponent } from "../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import { SliderReusableComponent } from "../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import {
  BackLogoIconButton,
  LoginTopLogoAndText,
} from "../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../store/actions/errorActions";

export class ResetPasswordSuccess extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (nextProps.auth.loader !== nextState.loading) {
      return {
        loading: nextProps.auth.loader,
      };
    }
    return null;
  }

  /******************************
   * @DESC - ON SUBMIT HANDLER
   *****************************/
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.history.push("/");
  };

  render() {
    const { loading } = this.state;
    if (loading) {
      return (
        <React.Fragment>
          <AmealioLoader />
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <Container fluid className="loginsignup-main">
          <Row>
            <Col className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 loginsignup-leftside">
              <div className="col-12 display-top-header-mobile">
                <BackLogoIconButton
                  displayHelpImage={true}
                  notDisplaProgressBar={true}
                />
              </div>
              <div className="col-12 loginsignup-section">
                <LoginTopLogoAndText bigText="Reset Password" />
              </div>
              <Col className="login-section-margin">
                <Col className="text-center reset-successful-logo">
                  <Image
                    src={require("./../../../assets/images/Login/reset.png")}
                  />
                </Col>
                <div className="col-12 p-0 login-bottom-text-success_password">
                  <h4>Your password was successfully reset</h4>
                  <p>Go Login Page</p>
                </div>
                <Col className="send-otp-top-margin-reset">
                  <ButtonReusableComponent
                    buttonText="Login"
                    buttonType="button"
                    buttonClass="activeLogin"
                    onClick={this.handleSubmit}
                  />
                </Col>
              </Col>
            </Col>
            <Col className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
              <SliderReusableComponent
                paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                bottomImage={
                  require("../../../assets/images/illustratorImage/Amealio_Illustrations-09.png")
                    .default
                }
              />
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

ResetPasswordSuccess.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  clear_all_errors,
})(withRouter(ResetPasswordSuccess));
